import { ModuleWithProviders, NgModule } from '@angular/core';

import { DragulaDirective } from './dragula.directive';
import { DragulaService } from './dragula.service';

@NgModule({
  exports: [DragulaDirective],
  declarations: [DragulaDirective],
})
export class DragulaModule {
  static forRoot(): ModuleWithProviders<DragulaModule> {
    return {
      ngModule: DragulaModule,
      providers: [DragulaService],
    };
  }
}
